import React from 'react';
import { texts } from 'utils/languages/fr';
import { ActionButton, CancelButton } from 'components';
import { Box } from '@mui/material';

const SectionActions = props => {
    const { handleCancel, handleSubmit, loading } = props;

    return (
        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={2} gap={2}>
            <CancelButton disabled={loading} onClick={handleCancel}>
                {texts.CANCEL}
            </CancelButton>
            <ActionButton disabled={loading} loading={loading} onClick={handleSubmit}>
                {texts.SAVE}
            </ActionButton>
        </Box>
    );
};

export default SectionActions;
